import Axios from 'axios'
import { Dispatch } from 'redux'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'
import { ActionResponse } from 'util/types/index'
import { OrderStatus, OrderStatusTypes } from './types'

export function createOrderStatus (data: any) {
  return async (dispatch: Dispatch): Promise<ActionResponse<OrderStatus>> => {
    return Axios
      .post('/order/status', data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: OrderStatusTypes.ORDER_STATUS_CREATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao cadastrar o status')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function updateOrderStatus (id: string|number, data: any) {
  return async (dispatch: Dispatch): Promise<ActionResponse<OrderStatus>> => {
    return Axios
      .put(`/order/status/${id}`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: OrderStatusTypes.ORDER_STATUS_UPDATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar o status')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function deleteOrderStatus (id: string|number) {
  return async (dispatch: Dispatch): Promise<ActionResponse<OrderStatus>> => {
    return Axios
      .delete(`/order/status/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: OrderStatusTypes.ORDER_STATUS_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover o status')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getOrderStatus (id: string|number) {
  return async (dispatch: Dispatch): Promise<ActionResponse<OrderStatus>> => {
    return Axios
      .get(`/order/status/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: OrderStatusTypes.ORDER_STATUS_GET, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao buscar o status')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getOrderStatusList () {
  return async (dispatch: Dispatch): Promise<ActionResponse<OrderStatus[]>> => {
    return Axios
      .get('/order/status/list')
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: OrderStatusTypes.ORDER_STATUS_GET_LIST, payload: res.data })
        }
        return res
      })
  }
}
